import { render, staticRenderFns } from "./IndividualSupportComp.vue?vue&type=template&id=62ef1e0c&scoped=true"
import script from "./IndividualSupportComp.vue?vue&type=script&lang=js"
export * from "./IndividualSupportComp.vue?vue&type=script&lang=js"
import style0 from "./IndividualSupportComp.vue?vue&type=style&index=0&id=62ef1e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef1e0c",
  null
  
)

/* custom blocks */
import block0 from "./IndividualSupportComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports